<script>

    import { _ } from 'svelte-i18n';

    import Section from '../components/Section.svelte'

</script>
    
<svelte:head>
    <title>{$_('oops')}</title>
</svelte:head>

<Section title={$_('oops')}>
    <p>{$_('error_page_not_found')}</p>
</Section>